import dayjs from "dayjs";
import { getBestPrice } from "../../../app/api/getBestPrice";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBestPriceRequest, IBestPriceResponse } from "../../../Orchestrator/Types/Index";
import { IGetBestPriceActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/CalendarBestPrice";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { determineDefaultAge } from "../../../Lib/Utils/validationUtil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

class GetBestPriceHorizontalCalendarAction extends BaseAction<IDefaultActionResult, IGetBestPriceActionParams> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { selectedTrip, calendarDayInterval, selectedRange, type = TrainTypeEnum.outbound, isChangeDate, changeDatePax, exchangeBeforePrice } = this.params!;

            if (selectedTrip && calendarDayInterval) {
                updateRecoilState("offerCalendarBestPriceAtom", []);
                let origin = (type == TrainTypeEnum.inbound && !isChangeDate) ? selectedTrip?.origin : selectedTrip?.from
                let destination = (type == TrainTypeEnum.inbound && !isChangeDate) ? selectedTrip?.destination : selectedTrip.to
                let departureDateFrom = dayjs(selectedTrip.departureDateTime)
                let departureDateTo = dayjs().add(calendarDayInterval, "day")
                if (departureDateFrom.isAfter(dayjs(), 'day') || departureDateFrom.isBefore(dayjs(), 'day')) {
                    departureDateFrom = dayjs();
                }
                // if (type === "inbound") {
                //     origin = selectedTrip.to
                //     destination = selectedTrip.from
                //     departureDateFrom = dayjs(selectedRange[0])
                //     departureDateTo = dayjs(selectedRange[0]).add(calendarDayInterval, "day")
                // }
                const payload: IBestPriceRequest = {
                    departureDateFrom: departureDateFrom.format("YYYY-MM-DD"),
                    departureDateTo: departureDateTo.format("YYYY-MM-DD"),
                    originStop: {
                        stopPlaceRef: origin || "",
                        objectType: "StopPlaceRef"
                    },
                    destinationStop: {
                        stopPlaceRef: destination || "",
                        objectType: "StopPlaceRef"
                    },
                    // passengers: selectedTrip.passengers.map(p => {
                    //     return { age: p.age }
                    // }),
                    passengers: (isChangeDate && changeDatePax?.length > 0) ? changeDatePax : Object.keys((type == TrainTypeEnum.inbound && !isChangeDate) ? selectedTrip.passengerCounts : selectedTrip.passengers).map((passengerType: any) => {
                        const count: any = (type == TrainTypeEnum.inbound && !isChangeDate) ? selectedTrip.passengerCounts[passengerType] : selectedTrip.passengers[passengerType]; // Get the count of passengers for this type
                        const age = determineDefaultAge(passengerType); // Get the corresponding age for this passenger type

                        // Create an array of passengers with the correct age based on the count
                        return Array.from({ length: count }, () => ({ age }));
                    }).flat(),
                    currency: "AED"
                }
                if (payload.originStop.stopPlaceRef != "") {
                    const response: any = await getBestPrice(payload, false); // price hints are widget data - no blocking loader
                    if (response.status === 'ok' && response.answer) {
                        const bestPriceResponse: IBestPriceResponse = response.answer;
                        const { prices } = bestPriceResponse
                        let sortByDateAscending = (prices || []).sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())

                        // Apply price adjustment only when the flag and condition are met
                        if (isChangeDate && Number(exchangeBeforePrice) > 0) {
                            sortByDateAscending = sortByDateAscending.map(item => ({
                                ...item,
                                price: Math.max(0, item.price - (Number(exchangeBeforePrice)))
                            }));
                        }


                        updateRecoilState("offerCalendarBestPriceAtom", sortByDateAscending || [])
                        actionResult.status = "success"
                        actionResult.data = sortByDateAscending
                    }
                }
            }
        } catch (error) {
            console.error("Error in GetBestPriceHorizontalCalendarAction:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const getBestPriceHorizontalCalendarAction = new GetBestPriceHorizontalCalendarAction()


